<template>
	<div class="nav navbar-nav justify-content-center nav-pills bg-white" :id="type+'-filter'">
		<div class="nav-item nav-link filter-wrapper" :class="{ 'active': isOpen }"> 
			<span @click="toggleFilter"><slot></slot></span> 
			<svg @click="toggleFilter" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" class="w-6 h-6" viewBox="0 0 24 24">
				<path stroke-linecap="round" stroke-linejoin="round" d="m20 8-7 8-7-8"/>
			</svg>
			<div class="picker" v-show="isOpen" 
				:style="{ 'right': lang=='he-IL'? '0':'unset', 'left': lang=='he-IL'? 'unset':'0' }">
				<div class="grid">
						<span v-for="type in contentTypes" @click="toggleType" :key="type">{{ type }}</span>
				</div>
				<div class="buttons-wrapper">
					<button @click="resetActive">
						{{ lang=='he-IL'? 'נקה':'Clear' }}
					</button>
					<button @click="closeFilter">
						{{ lang=='he-IL'? 'סנן':'Filter' }}
					</button>
				</div>
				<div class="close-button" @click="closeFilter"
					:style="{ 'right': lang=='he-IL'? '100%':'unset',  'left': lang=='he-IL'? 'unset':'100%' }">
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor">
						<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
					</svg>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		contentTypes: {
			type: Set,
			required: true
		},
		type: {
			type: String,
			required: true
		},
	},
	data() {
		return {
			isOpen: false,
			lang: 'he-IL',
			activeTypes: []
		}
	},
	methods: {
		resetActive(e, noFiltering) {
			this.activeTypes = []
			document.querySelectorAll(".grid span").forEach(function(elm) {
				elm.classList.remove('active')
			})
			if (!noFiltering) this.filterPosts()
		},
		closeFilter() {
			this.isOpen = false;
		},
		debounceFilterPosts() {
			if (this.filterDebounceResolveID) clearTimeout(this.filterDebounceResolveID)
			this.filterDebounceResolveID = setTimeout(this.filterPosts, 700)
		},
		filterPosts() {
			let filterObj = {
				name: this.type,
				active: this.activeTypes
			}
			this.emitter.emit('filterByContent', filterObj)
		},
		toggleType(e) {
			let type = e.target.innerText
			let active = e.target.classList.contains('active')
			e.target.classList.toggle('active')
			if (active) this.activeTypes.splice(this.activeTypes.indexOf(type), 1)
			else this.activeTypes.push(type)
			this.debounceFilterPosts() 
		},
		toggleFilter() {
			if (this.isOpen) this.closeFilter()
			else this.openFilter()
		},
		openFilter() {
			document.body.addEventListener("click", this.closeFilterOnBodyClick)
			this.isOpen = true
		},
		closeFilterOnBodyClick(e) {
			let testElm = e.target
			for (let i=0; i<6; i++) {
				if (testElm == document.querySelector(`#${this.type}-filter`)) return
				if (!testElm.parentNode) break
				testElm = testElm.parentNode
			}
			this.closeFilter()
			document.body.removeEventListener("click", this.closeFilterOnBodyClick)
		},
		recursiveHighlighTag(tag, counter) {
			if (!counter) counter=0
			this.activeTypes = [tag]
			let tagElements = document.querySelectorAll("#tags-filter .grid span")
			if (!tagElements.length && counter<30) {
				setTimeout(this.recursiveHighlighTag, 1000, tag, ++counter)
			} else {
				document.querySelectorAll(".grid span").forEach(function(elm) {
					if (elm.innerText == tag) elm.classList.add('active')
				})
			}
		}
	},
	mounted() {
		if (this.type == "tags") {
			this.emitter.on('highlightTag', this.recursiveHighlighTag) 
		}
		this.emitter.on('resetAllContentFilters', _ => {
			this.resetActive(null, true)
			this.closeFilter()
		})
		this.lang = document.getElementsByTagName('html')[0].getAttribute('lang')
	}
};
</script>

<style>
.navbar-nav {
  border: 2px solid black;
  margin-inline-end: 1em;
}
.nav-link {
  padding: .1rem 1rem !important;
  transition: all 400ms;
}
.filter-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 5px;
  padding-inline: 0.5em !important;
}

.filter-wrapper.active {
  color: white;
  background-color: black;
}

.filter-wrapper svg {
  transition: 300ms ease-in-out;
}
.filter-wrapper.active svg {
  transform: rotate(360deg) scale(-1);
}

a.nav-link {
  outline: none !important;
}
.spa-nav .nav-pills .nav-link.active,
.spa-nav .nav-pills .show > .nav-link {
	background-color: black;
	border-radius: 0;
}

.picker {
	--pink: #F15794;
	min-width: 236px;
	min-height: 160px;
	position: absolute;
	top: 2em;
	right: 0;
	z-index: 1;
	padding: 8px;
	border: 2px solid black;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-shadow: 0px 3px 6px #00000080;
	background-color: white;
}

@media only screen and (max-width: 480px) {
	.picker {
		right: 35vw;
		transform: translateX(50%);
	}

}

.grid {
	display: grid;
	grid-gap: 5px;
	grid-template-columns: 1fr 1fr;
	font-size: 0.8em;
	color: black;
	padding-block: 0 16px;
}

.grid span {
	border: 1px solid black;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	padding: 1px;
	cursor: pointer;
}

.grid span.active {
	color: white;
}

.buttons-wrapper {
	display: flex;
	justify-content: space-between;
}


.buttons-wrapper button {
	position: relative;
	color: var(--pink);
	background-color: white;
	border: 1px solid var(--pink);
	box-shadow: 0px 3px 6px #00000080;
	padding: 0 1em !important;
	transition: 300ms ease-in-out;
}

.buttons-wrapper button:focus {
	outline: none !important;
	background-color: white;
}

.buttons-wrapper button:nth-child(2):focus {
	background-color: var(--pink);
}

.buttons-wrapper button:nth-child(2) {
	background-color: var(--pink);
	color: white;
	border: 1px solid white;
}

.buttons-wrapper button:hover {
	bottom: 2px;
	background-color: white;
}

.buttons-wrapper button:nth-child(2):hover {
	background-color: var(--pink);
}

.close-button {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 0;
	height: 1.2em;
	width: 1.2em;
	color: white;
	background: black;
	cursor: pointer;
}
</style>

